import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  chip: {
    width: 68,
    margin: '0 5px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  imgContainer: {
    width: 60,
    height: 60,
    border: `4px solid ${theme.colors.light.ghostWhite}`,
    borderRadius: 14,
    position: 'relative',

    '@media (max-width: 379px)': {
      width: 50,
      height: 50,
    },
  },
  img: {
    margin: 'auto',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
  },
  chipTitle: {
    fontSize: theme.fonts.sizes.font10PX,
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',

    '@media (max-width: 379px)': {
      fontSize: theme.fonts.sizes.font9PX,
    },
  },
}));
